import { isZumper } from '@zcode/env'

export const BASE_COLOR = isZumper ? '#2E64E2' : '#3CB86C'
export const BLACK = '#000000'
export const BLACK_LIGHTER = '#25323E'
export const BLUE = '#5AB8F8'
export const BLUE_BACKGROUND = '#F6F9FC'
export const BLUE_LIGHT = '#D9F5FF'
export const BLUE_DARK = '#009EE3'
export const GRAY000 = '#888699'
export const GRAY30 = '#DFE2E4'
export const GRAY050 = '#8F9294'
export const GRAY90 = '#4E5865'
export const GRAY300 = '#D8D8D8'
export const GRAY400 = '#C6C6CC'
export const GRAY450 = '#C9D1D4'
export const GRAY500 = '#727272'
export const GRAY510 = '#727577'
export const GRAY600 = '#9B9B9B'
export const GRAY650 = '#EFEFF4'
export const GRAY700 = '#F1F1F4'
export const GRAY800 = '#F7F7F8'
export const GREEN = '#3CB86C'
export const GREEN_BRIGHT = '#00AD0E'
export const HISTOGRAM_BAR = isZumper ? '#EEEBE9' : '#D8D8D8'
export const HISTOGRAM_BAR_SELECTED = isZumper ? '#BEC8CF' : '#97D2FB'
export const INK = '#2A2B2C'
export const NONE = 'none'
export const ORANGE_WARNING = '#E67500'
export const PINKISH_RED = '#EF5062'
export const PINK = '#FF0082'
export const PINK_LIGHT = '#FF8EB1'
export const PINK_LIGHTISH = '#FF66B4'
export const PINK_DARK = '#E82662'
export const RED = '#E53343'
export const RED_ERROR = '#E32C0E'
export const SLATE_DARK = '#4F5C68'
export const SLATE_LIGHT = '#E4E7E9'
export const WHITE = '#FFFFFF'
export const YELLOW = '#FAD134'
export const MF_TOUR_BLUE = '#5B87ED'
